type Components = 'CompetenceCard' | 'ItemSingle' | 'ProfessionListCard' | 'OrganizationSingleItem';

const listCardSetup = (
  title: string,
  component: Components,
  list: Array<Object>,
) => {
  if (!Array.isArray(list) || !list.length) return [];
  return [
    {
      title,
      component,
      list,
    },
  ];
};

export default listCardSetup;



// WEBPACK FOOTER //
// ./src/tools/listCardSetup.ts